export const STRINGS = {
  buttonOpen: 'Ouvrir le chat',
  buttonClose: 'Fermer le chat',
  windowTitle: 'Bokame Assistant',
  inputPlaceholder: 'Tapez votre message…',
  send: 'Envoyer',
  aiThinking: "L'assistant rédige sa réponse…",
  agentJoined: 'Notre équipe vous a rejoint.',
  connectionLost: 'Connexion perdue, reprise en cours…',
  connectionFailed: 'Indisponible. Réessayer ?',
  retry: 'Réessayer',
  empty: 'Bonjour ! Comment puis-je vous aider ?',
  welcomeHumanMode:
    'Bonjour, posez-nous votre question, Baptiste ou Juliette vous répond personnellement.',
  unreadBadgeLabel: 'nouveaux messages',
  privacyPrefix: 'En envoyant un message, vous acceptez notre ',
  privacyLinkText: 'politique de confidentialité',
  contactEmailLabel: 'Votre e-mail',
  contactEmailPlaceholder: 'vous@exemple.fr',
  contactNameLabel: 'Prénom (optionnel)',
  contactNamePlaceholder: 'Prénom',
  contactSubmit: 'Valider',
  contactInvalidEmail: 'Merci de renseigner une adresse e-mail valide.',
  contactSoftInvite:
    'Laissez-nous votre e-mail pour recevoir notre réponse même si vous quittez le site.',
  contactDismiss: 'Fermer',
  contactPendingMessage: 'Votre message sera envoyé dès votre e-mail validé.',
  ackOnline: 'Message envoyé. Nous vous répondons dès que possible.',
  ackOffline: 'Message envoyé. Nous vous répondrons par e-mail.',
  sendFailed: 'Non envoyé.',
  sendRetry: 'Réessayer',
  attachAdd: 'Ajouter une photo',
  attachRemove: 'Retirer la photo',
  attachUploading: 'Envoi…',
  attachOpen: 'Ouvrir la photo',
  attachAlt: 'Photo envoyée dans la conversation',
  attachErrorFormat: 'Format non pris en charge, envoyez une photo JPEG ou PNG.',
  attachErrorTooLarge: 'Image trop lourde (8 Mo maximum).',
  attachErrorGeneric: "L'envoi de la photo a échoué, réessayez.",
  attachErrorTooMany: 'Vous pouvez joindre 4 photos au maximum.',
  attachExpired: 'Photo expirée, veuillez la renvoyer.',
  // D16 : placeholder affiché à la place d'une image déjà reçue dont l'URL
  // signée a expiré (7 jours) — distinct de `attachExpired` ci-dessus, qui
  // concerne un envoi en cours, pas une image déjà affichée dans l'historique.
  attachImageExpired: 'Image expirée',
  // Pièce jointe non-image reçue de l'agent (PDF — feat/attachments-files) :
  // rendue comme un lien fichier plutôt qu'une miniature.
  attachFileOpen: 'Ouvrir le fichier',
} as const;
